var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card-foot-item',[_c('core-card-foot-item-value',{attrs:{"type":"text"}},[_c('div',{staticClass:"language-band",class:{[_vm.bandClass]: true}},[_vm._v(_vm._s(_vm.name))])]),_c('core-card-foot-item-label',[_vm._v(_vm._s(_vm.field.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }